import Vue from 'vue';
import App from './App.vue';
import Element from 'element-ui';
import '@/assets/styles/normalize.css';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store';
import router from './router';
// import JsonViewer from 'vue-json-viewer';
// import { reportVisit } from './common/beacon';

Vue.config.productionTip = false;

Vue.use(Element);
// Vue.use(JsonViewer);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
